export const AUDIO_CREATE_RESET = 'AUDIO_CREATE_RESET';
export const AUDIO_CREATE_SET_CREATED = 'AUDIO_CREATE_SET_CREATED';
export const AUDIO_CREATE_SET_ERROR = 'AUDIO_CREATE_SET_ERROR';
export const AUDIO_CREATE_SET_VIOLATIONS = 'AUDIO_CREATE_SET_VIOLATIONS';
export const AUDIO_CREATE_TOGGLE_LOADING = 'AUDIO_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/audio/create/mutation_types.js